import { render } from "./optionTag.vue?vue&type=template&id=12328e36&scoped=true"
import script from "./optionTag.vue?vue&type=script&lang=js"
export * from "./optionTag.vue?vue&type=script&lang=js"

import "./optionTag.vue?vue&type=style&index=0&id=12328e36&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12328e36"]])

export default __exports__